import { useRef } from "react";
import { Link } from "react-router-dom";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { TitleCard } from "@/components/catalog/TitleCard";
import { ContinueCard } from "@/components/catalog/ContinueCard";

export const Rail = ({ title, items, wide = false, seeAll, testId }) => {
  const ref = useRef(null);
  const scroll = (dir) => ref.current?.scrollBy({ left: dir * ref.current.clientWidth * 0.85, behavior: "smooth" });
  return (
    <section data-testid={testId} className="group/rail relative">
      <div className="mx-auto flex max-w-[1680px] items-center justify-between px-4 sm:px-6 lg:px-10">
        <h2 className="flex items-center gap-2.5 rail-title text-[0.8rem] sm:text-sm md:text-base gold-text">
          <span className="h-4 w-[3px] flex-none rounded-full bg-gradient-to-b from-[#FFD86A] to-[#8A6A1F]" />
          {title}
        </h2>
        {seeAll && (
          <Link to={seeAll} data-testid={`${testId}-see-all`} className="flex items-center gap-1 text-xs sm:text-sm font-semibold text-[#D4AF37]/80 hover:text-[#FFD86A] transition-colors">
            See all <ChevronRight className="h-4 w-4" />
          </Link>
        )}
      </div>
      <div className="relative mx-auto max-w-[1680px]">
        <button
          data-testid={`${testId}-prev`}
          onClick={() => scroll(-1)}
          aria-label="Scroll left"
          className="hidden md:grid absolute left-1 lg:left-3 top-1/2 z-20 -translate-y-1/2 h-12 w-12 place-items-center rounded-full glass text-[#FFD86A] opacity-0 group-hover/rail:opacity-100 transition-opacity hover:bg-[#D4AF37]/20"
        >
          <ChevronLeft className="h-6 w-6" />
        </button>
        <div ref={ref} className="no-scrollbar flex gap-2.5 sm:gap-3 lg:gap-4 overflow-x-auto scroll-smooth snap-x snap-mandatory px-4 sm:px-6 lg:px-10 pt-3 pb-4 md:pt-5 md:pb-5 scroll-px-4 sm:scroll-px-6 lg:scroll-px-10">
          {items.map((it) => (wide ? <ContinueCard key={`${it.title.slug}-${it.episode?.id || ""}`} item={it} /> : <TitleCard key={it.slug} title={it} />))}
        </div>
        <button
          data-testid={`${testId}-next`}
          onClick={() => scroll(1)}
          aria-label="Scroll right"
          className="hidden md:grid absolute right-1 lg:right-3 top-1/2 z-20 -translate-y-1/2 h-12 w-12 place-items-center rounded-full glass text-[#FFD86A] opacity-0 group-hover/rail:opacity-100 transition-opacity hover:bg-[#D4AF37]/20"
        >
          <ChevronRight className="h-6 w-6" />
        </button>
      </div>
    </section>
  );
};
